import SurveyTextInput from './SurveyTextInput';
import SurveySelectInput from './SurveySelectInput';
import SurveyMultiSelectInput from './SurveyMultiSelectInput';
import SurveyLocationInput from './SurveyLocationInput';

export const SURVEY_INPUT_COMPONENTS = {
  text: SurveyTextInput,
  select: SurveySelectInput,
  multi_select: SurveyMultiSelectInput,
  number: SurveyTextInput,
  date: SurveyTextInput,
  url: SurveyTextInput,
  location: SurveyLocationInput
};